export default {"src":"/_next/static/media/icon_more_contact.9beda8d6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};